import { SortTypeEnum } from '.';
import { ApiResponseType } from './api';

export type ReportReviewRequestType = {
    Start: number;
    Limit: number;
    'ReportedBy.FilterValue'?: string;
    'ReportedBy.SortType'?: SortTypeEnum;
    'CandidateName.FilterValue'?: string;
    'CandidateName.SortType'?: SortTypeEnum;
    'CompanyName.FilterValue'?: string;
    'CompanyName.SortType'?: SortTypeEnum;
    'OfferType.FilterValue'?: string;
    'OfferType.SortType'?: SortTypeEnum;
    'ReviewType.FilterValue'?: string;
    'ReviewType.SortType'?: SortTypeEnum;
    'ReportedDate.FilterValue'?: string;
    'ReportedDate.SortType'?: SortTypeEnum;
    'CurrentStatus.FilterValue'?: string;
    'CurrentStatus.SortType'?: SortTypeEnum;
};

export type ReportReviewListType = {
    reportedBy: string;
    candidateName: string;
    companyName: string;
    offerType: number;
    reviewType: number;
    reportedDate: Date;
    currentStatus: reportReviewStatusEnum;
    offerId: string;
    reportReviewId: string;
    reviewId: string;
    reviewText: string;
    suspendedReasons: string;
    reportReplyId?: string;
    replyId?: string;
    reviewCommentId?: string;
    replyText?: string;
    reviewReplyText?: string;
    suspendStatus?: number;
};

export type GetReportReviewResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: ReportReviewListType[];
        hasMore: boolean;
        count: number;
    };
};

export type ReportReplyRequestType = {
    Start: number;
    Limit: number;
    'ReportedBy.FilterValue'?: string;
    'ReportedBy.SortType'?: SortTypeEnum;
    'CandidateName.FilterValue'?: string;
    'CandidateName.SortType'?: SortTypeEnum;
    'CompanyName.FilterValue'?: string;
    'CompanyName.SortType'?: SortTypeEnum;
    'OfferType.FilterValue'?: string;
    'OfferType.SortType'?: SortTypeEnum;
    'ReviewType.FilterValue'?: string;
    'ReviewType.SortType'?: SortTypeEnum;
    'ReportedDate.FilterValue'?: string;
    'ReportedDate.SortType'?: SortTypeEnum;
    'CurrentStatus.FilterValue'?: string;
    'CurrentStatus.SortType'?: SortTypeEnum;
};

export type ReportReplyListType = {
    reportedBy: string;
    candidateName: string;
    companyName: string;
    offerType: number;
    reviewType: number;
    reportedDate: Date;
    currentStatus: reportReviewStatusEnum;
};

export type GetReportReplyResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: ReportReviewListType[];
        hasMore: boolean;
        count: number;
    };
};

export enum reportReviewStatusEnum {
    underReview = 1,
    actionTaken = 2,
    actionNotTaken = 3,
}
export enum reportOfferType {
    normalOffer = 0,
    coe = 1,
    coeOnOffer = 2,
    offline = 3,
    external = 4,
    dataPunch = 5,
}

export type ReportedDetailsRequestType = {
    reportReviewType: ReportReviewType;
    reviewId: string;
    replyId?: string;
};

export type PartnerReportedDetailsRequestType = {
    reportReviewType: PartnerReportReviewType;
    reviewId: string;
    replyId: string;
};

export type replies = {
    candidateFirstName: string;
    candidateId: string;
    candidateLastName: string;
    candidateRepliedTimes: number;
    companyId: string;
    companyName: string;
    companyRepliedTimes: number;
    date: string;
    id: string;
    offerId: string;
    parentCommentId: string | null;
    repliedById: string;
    repliedByName: string;
    repliedByRole: number;
    replyEditedDate: string;
    replyEditedTimes: number;
    replyText: string;
    reviewId: string;
    suspendStatus: number;
    wasReplyEdited: boolean;
    candidateAvatarUrl: string;
    companyAvatarUrl: string;
};

export enum ContractComplianceStateEnum {
    ContractCompliance,
    ContractViolation,
}

export type ReportedDetailsResponseType = {
    contractComplianceState: number;
    contractViolationReason: string;
    date: string;
    id: string;
    jobStartDate: string;
    jobTitle: string;
    offerId: string;
    offerState: number;
    offerType: number;
    replies: replies[];
    reviewCreatedDate: string;
    reviewEditedDate: string;
    reviewEditedTimes: number;
    reviewText: string;
    reviewType: number;
    revieweeAvatarUrl: string;
    revieweeId: string;
    revieweeName: string;
    reviewerAvatarUrl: string;
    reviewerId: string;
    reviewerName: string;
    stars: { value: number };
    suspendStatus: number;
    wasReviewEdited: boolean;
    isOnboardingReview: boolean;
};

export type PartnerReportedDetailsResponseType = {
    contractComplianceState: number;
    id: string;
    isReviewReported: boolean;
    modifiedDate: string;
    reportedOnCompanyName: string;
    partnerReviewReportedText: string;
    partnerReplies: {
        id: string;
        isReplyReported: boolean;
        managerId: string;
        parentReplyId: string | null;
        partnerReviewId: string;
        repliedBYCompanyName: string | null;
        replyDate: string;
        replyLevel: number;
        replyText: string;
        reportStatus: number;
        avatarUrl: string;
        companyName: string;
        partnerReplyReportedText: string;
        suspendedReasons: {
            id: string;
            suspendedReasonCategoryId: string;
            suspendedReasonId: string;
            suspendedReasonText: string;
            suspendedReasonTitle: string;
        }[];
    }[];
    rating: number;
    reportStatus: number;
    reviewReportStatus: number;
    reportedByAvatarUrl: string;
    reportedOnAvatarUrl: string;
    reviewText: string;
    reviewType: number;
    partnerReviewId: string;
    isOnboardingReview: boolean;
    suspendedReasons: {
        id: string;
        suspendedReasonCategoryId: string;
        suspendedReasonId: string;
        suspendedReasonText: string;
        suspendedReasonTitle: string;
    }[];
};

export type GetReportedDetailsResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: ReportedDetailsResponseType;
};

export type ReportedActionRequestType = {
    reviewType: ReportReviewType;
    reviewId: string;
    offerId: string;
    replyId: string | null;
    reportReviewId: string | null;
    reportReplyId: string | null;
    suspendStatus: number;
    reviewReplyText: string;
    partnerReviewReportedText?: string | null;
    currentStatus?: number;
};

export type PartnerReportedActionRequestType = {
    reviewType: ReportReviewType;
    reviewId: string;
    offerId: string;
    replyId: string | null;
    reportReviewId: string | null;
    reportReplyId: string | null;
    suspendStatus: number;
    reviewReplyText: string;
    currentStatus?: number;
};

export enum ReviewAndCommentSuspendStatus {
    NotFlagged = 0,
    UnderReview = 1,
    ActionTaken = 2,
    ActionNotTaken = 3,
}

export enum ReportReviewType {
    CandidateReview,
    CompanyReview,
}

export enum PartnerReportReviewType {
    PartnerReview,
}
